/**
 * Stable, greppable marker written to the log whenever a session becomes
 * active (created, resumed, or switched to — see
 * `DefaultSessionManager#createAndActivateSession`).
 *
 * `duo log session-id <id>` searches log file contents for this exact marker to
 * find which file(s) a given session's logs live in. A session resumed
 * across separate `duo` invocations can span more than one log file, since
 * each process gets its own file.
 */
const SESSION_LOG_MARKER_PREFIX = 'Created session:';

export function formatSessionLogMarker(sessionId: string): string {
  return `${SESSION_LOG_MARKER_PREFIX} ${sessionId}`;
}

/**
 * Matches `formatSessionLogMarker(sessionId)` anchored to the end of a line,
 * so a short id like "42" doesn't match a line ending in "422".
 */
export function buildSessionLogMarkerPattern(sessionId: string): RegExp {
  const escapedId = sessionId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(`${SESSION_LOG_MARKER_PREFIX} ${escapedId}$`, 'm');
}
